/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Plan_Build_DetailsInputs */

const en_us2_plan_build_details = /** @type {(inputs: Plan_Build_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`See details of ${i?.name}`)
};

const pt_br2_plan_build_details = /** @type {(inputs: Plan_Build_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalhes de ${i?.name}`)
};

const es_419_plan_build_details = /** @type {(inputs: Plan_Build_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalles de ${i?.name}`)
};

const pt_pt2_plan_build_details = /** @type {(inputs: Plan_Build_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalhes de ${i?.name}`)
};

const fr_fr2_plan_build_details = /** @type {(inputs: Plan_Build_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voir les détails de ${i?.name}`)
};

const de_de2_plan_build_details = /** @type {(inputs: Plan_Build_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Details zu ${i?.name} ansehen`)
};

const it_it2_plan_build_details = /** @type {(inputs: Plan_Build_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vedi i dettagli di ${i?.name}`)
};

/**
* | output |
* | --- |
* | "See details of {name}" |
*
* @param {Plan_Build_DetailsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_details = /** @type {((inputs: Plan_Build_DetailsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_DetailsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_details(inputs)
	if (locale === "es-419") return es_419_plan_build_details(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_details(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_details(inputs)
	if (locale === "de-DE") return de_de2_plan_build_details(inputs)
	if (locale === "it-IT") return it_it2_plan_build_details(inputs)
	return en_us2_plan_build_details(inputs)
});
export { plan_build_details as "plan-build.details" }